import { render, staticRenderFns } from "./AparelhosModal.vue?vue&type=template&id=71bb27f0&scoped=true"
import script from "./AparelhosModal.vue?vue&type=script&lang=js"
export * from "./AparelhosModal.vue?vue&type=script&lang=js"
import style0 from "./AparelhosModal.vue?vue&type=style&index=0&id=71bb27f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb27f0",
  null
  
)

export default component.exports